import { Box, Button } from "@mui/material";
import React from "react";
import colors from "../../../shared/themes/colors";
import { GroupedStockItem } from "../../shared/models/customerBuyerStockItemsModels";
import { productCondition, unitCode } from "../../../common/models/CommonModels";
import { country } from "../../../shared/models/countryModels";
import OverflowTooltip from "../../../shared/components/OverflowTooltip";
import Chips from "../../../shared/components/chips/Chips";
import PriceRangeFormat from "../../../shared/components/formats/PriceRangeFormat";
import ImageList from "../../../shared/components/images/ImageList";
import useTranslation from "../../../shared/hooks/useTranslation";

interface StockCardProps {
  item?: GroupedStockItem;
  active?: boolean;
  onShowSuppliers?: () => void;
}

const GroupedStockItemCard = ({ item, active = false, onShowSuppliers }: StockCardProps) => {
  const handleShowSuppliers = () => {
    onShowSuppliers?.();
  };
  const { translate } = useTranslation(["marketplace", "common"]);

  return (
    <Box
      className="w-full flex justify-between"
      sx={{
        border: `1px solid ${active ? colors.primary.strokeBlue : colors.secondary.gray90}`,
        minHeight: "160px",
        borderRadius: "8px",
        padding: "16px"
      }}
    >
      <Box className="flex gap-4" sx={{ width: "382px" }}>
        <ImageList images={item?.images} />

        <Box>
          <Box sx={{ maxWidth: "230px" }}>
            <OverflowTooltip text={item?.number} className="text-14-bold" color={"#333333"} />
            <Box className="text-14-regular">{item?.alternativeNumber}</Box>
          </Box>

          <Box className="mt-4">
            <Box className="text-14-regular" color={"#333333"}>
              {item?.manufacturerName}
            </Box>
            <Box className="text-14-regular" color={"#747881"}>
              {item?.categoryName}
            </Box>
          </Box>
        </Box>
      </Box>

      <Box sx={{ width: "300px" }}>
        <Box className="text-14-medium mb-1" color="#333333">
          {translate("suppliersInCountries", { suppliers: item?.suppliersCount, countries: item?.countryIds?.length })}
        </Box>

        <Chips
          value={item?.countryIds.map(countryId => country(countryId)?.name as string)}
          maxLength={4}
        />
      </Box>

      <Box className="flex flex-col items-end justify-between" sx={{ minWidth: "147px" }}>
        <Box className="flex flex-col items-end">
          <PriceRangeFormat
            className="text-14-bold mb-2"
            color="#333333"
            minValue={item?.minPrice}
            maxValue={item?.maxPrice}
          />

          <Chips value={item?.productConditions.map(code => translate(`common:productCondition.${productCondition(code)}`))} />
        </Box>

        <Box className="text-14-regular">{item?.quantity.value} {translate(`common:measurementUnits.${unitCode(item?.quantity.unitCode)}`)}</Box>

        {!!onShowSuppliers && (
          <Button variant="text" className="text-14-medium" onClick={handleShowSuppliers}>
            {translate("showSuppliers")}
          </Button>
        )}
      </Box>
    </Box>
  );
};

export default GroupedStockItemCard;
